<template>
  <v-layout>
    <div class="col">
      <v-store-user-info />
      <payment-breadcrumb :step="3"/>
      <article>
        <header>
          <h1>{{ $t('paymentSelection.title') }}</h1>
        </header>
      </article>
    </div>
  </v-layout>
</template>

<script>
import { SET_ORDER_STATUS } from '../store/modules/cart/mutation-types'
import { ORDER_STATUS_FAILED_PAYMENT, ORDER_STATUS_UNKNOWN } from '../order-api/order-api-client-constants'
import { buildOrderStatus } from '../types/order-status'
import bodyClassMixin from '../mixins/body-class'
import VLayout from '../layouts/PaymentFlow'
import VStoreUserInfo from '../components/user/StoreUserInfo'
import PaymentBreadcrumb from '../components/PaymentBreadcrumb'

export default {
  name: 'PaymentStatusPage',
  components: {
    VLayout,
    VStoreUserInfo,
    PaymentBreadcrumb
  },
  mixins: [
    bodyClassMixin
  ],
  mounted: async function () {
    try {
      const orderStatus = await this.$container.orderApiClient.getOrderStatus(
        this.$store.state.cart.orderCreated.orderId,
        this.$store.state.cart.orderCreated.orderToken
      )

      this.confirmation(orderStatus)
    } catch (error) {
      this.confirmation()
    }
  },
  methods: {
    confirmation: function (orderStatus = null) {
      if (!orderStatus) {
        orderStatus = buildOrderStatus()
        orderStatus.status = ORDER_STATUS_UNKNOWN
      }

      this.$store.commit('cart/' + SET_ORDER_STATUS, orderStatus)

      if (orderStatus.status === ORDER_STATUS_FAILED_PAYMENT) {
        this.$router.push({ name: 'PaymentSelection' }).catch(() => {})
      } else {
        this.$router.push({ name: 'PaymentConfirmation' }).catch(() => {})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PaymentStatus.vue